import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_EditThirdPartyCompany = _resolveComponent("EditThirdPartyCompany")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_ThirdCompanyUsersEdition = _resolveComponent("ThirdCompanyUsersEdition")!
  const _component_ThirdCompanyIbansEdition = _resolveComponent("ThirdCompanyIbansEdition")!
  const _component_StockProductCompanyEdition = _resolveComponent("StockProductCompanyEdition")!
  const _component_ThirdPartyCompanyTag = _resolveComponent("ThirdPartyCompanyTag")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
            class: "tab_budget_form_mobile",
            mandatory: ""
          }, {
            default: _withCtx(() => [
              (_ctx.showEditCompany)
                ? (_openBlock(), _createBlock(_component_v_tab, {
                    key: 0,
                    ripple: "",
                    value: "EditCompany",
                    "data-cy": "companiesTable-editCompany-tab"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("Edition Société")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showCompanyContacts)
                ? (_openBlock(), _createBlock(_component_v_tab, {
                    key: 1,
                    ripple: "",
                    value: "CompanyContacts",
                    "data-cy": "companiesTable-companiesContacts-tab"
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("Contacts Société")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showCompanyIBANS)
                ? (_openBlock(), _createBlock(_component_v_tab, {
                    key: 2,
                    ripple: "",
                    value: "CompanyIBANS",
                    "data-cy": "companiesTable-companyIBANS-tab"
                  }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode("IBANS")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showCompanyProducts)
                ? (_openBlock(), _createBlock(_component_v_tab, {
                    key: 3,
                    ripple: "",
                    value: "CompanyProducts",
                    "data-cy": "companiesTable-CompanyProducts-tab"
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                      _createTextVNode("Produits")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showTagRules)
                ? (_openBlock(), _createBlock(_component_v_tab, {
                    ripple: "",
                    key: "TagRules",
                    value: "TagRules",
                    href: "#TagRules",
                    "data-cy": "companiesTable-TagRules-tab"
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("Etiquettes")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.activeTab) = $event))
          }, {
            default: _withCtx(() => [
              (_ctx.showEditCompany && _ctx.activeTab === 'EditCompany')
                ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                    key: 0,
                    value: "EditCompany"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditThirdPartyCompany, {
                        actions: _ctx.actions,
                        inThirdPartyCompanyId: _ctx.thirdPartyCompanyId,
                        parentCompanyId: _ctx.companyId,
                        ref: "editCompanyIndex",
                        onUpsert: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitUpsert($event)))
                      }, null, 8, ["actions", "inThirdPartyCompanyId", "parentCompanyId"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showCompanyContacts && _ctx.activeTab === 'CompanyContacts')
                ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                    key: 1,
                    value: "CompanyContacts"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ThirdCompanyUsersEdition, {
                        onlyToCreate: false,
                        companyId: _ctx.companyId,
                        inThirdPartyCompanyId: _ctx.thirdPartyCompanyId,
                        showEditUsers: true,
                        actions: _ctx.actions,
                        onCreateUser: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitCreateUser($event))),
                        onEmitUpsert: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refreshApollo($event))),
                        onStep: _cache[4] || (_cache[4] = ($event: any) => (_ctx.emitStepFromComponent($event))),
                        onEditMode: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emitEditMode())),
                        ref: "thirdCompanyUsersIndex"
                      }, null, 8, ["companyId", "inThirdPartyCompanyId", "actions"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showCompanyIBANS && _ctx.activeTab === 'CompanyIBANS')
                ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                    key: 2,
                    value: "CompanyIBANS"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ThirdCompanyIbansEdition, {
                        companyId: _ctx.companyId,
                        inThirdPartyCompanyId: _ctx.thirdPartyCompanyId,
                        thirdPartyCompanyType: _ctx.thirdPartyCompanyType,
                        showEditUsers: true,
                        actions: _ctx.actions,
                        onIbanRules: _cache[6] || (_cache[6] = ($event: any) => (_ctx.emitCreateIban($event))),
                        onEmitUpsert: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refreshApollo($event))),
                        onStep: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emitStepFromComponent($event))),
                        onEditMode: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emitEditMode())),
                        ref: "thirdCompanyIbansIndex"
                      }, null, 8, ["companyId", "inThirdPartyCompanyId", "thirdPartyCompanyType", "actions"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showCompanyProducts && _ctx.activeTab === 'CompanyProducts')
                ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                    key: 3,
                    value: "CompanyProducts"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_StockProductCompanyEdition, {
                        companyId: _ctx.companyId,
                        inThirdPartyCompanyId: _ctx.thirdPartyCompanyId,
                        actions: _ctx.actions,
                        onEmitUpsert: _cache[10] || (_cache[10] = ($event: any) => (_ctx.refreshApollo($event))),
                        onStep: _cache[11] || (_cache[11] = ($event: any) => (_ctx.emitStepFromComponent($event))),
                        onEditMode: _cache[12] || (_cache[12] = ($event: any) => (_ctx.emitEditMode())),
                        ref: "stockProductIndex"
                      }, null, 8, ["companyId", "inThirdPartyCompanyId", "actions"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showTagRules && _ctx.activeTab === 'TagRules')
                ? (_openBlock(), _createBlock(_component_v_tabs_window_item, {
                    key: 4,
                    value: "TagRules"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ThirdPartyCompanyTag, {
                        companyId: _ctx.companyId,
                        actions: _ctx.actions,
                        thirdPartyCompanyId: _ctx.thirdPartyCompanyId
                      }, null, 8, ["companyId", "actions", "thirdPartyCompanyId"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}